import {   DeheadingPeelingResponseModel, DeheadingPeelingColumns, DeheadingFilterReq, ScopeGradeReq, DeheadingPeelingRequest } from "@gtpl/shared-models/masters";
import { Injectable } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import { Repository,Connection,Like, getManager } from "typeorm";
import { DeheadingPeelingEntity } from "./deheading-peeling-entity";
import { DeheadingPeelingAdapter } from "./dto/deheading-peeling-adapter";
import { ErrorResponse, OperationTypeEnum } from "@gtpl/shared-models/common-models";
import { DeheadingPeelingDTO } from "./dto/deheading-peeling.dto";
import { DeheadingPeelingRequests } from "./dto/deheading-peeling.request";
import { GenericTransactionManager } from "apps/services/backend/typeorm-transactions/generic-transaction-manager";
import { DeheadingPeelingLogsEntity } from "./deheading-peeling-logs.entity";
import { DeheadingPeelingColumnsDto } from "./dto/deheading-peeling-columns-dto";
import { FoodType } from "../food-types/food-types.entitiy";
import { ValueAdditionOneType } from "../value-addition1-types/value-addition-one.entity";
import { ValueAdditionTwoType } from "../value-addition2-types/value-addition-two.entity";
import { CommonResponse } from "@gtpl/shared-models/production-management";
import { appSettings } from "apps/services/config";
import { log } from "util";
import { ValueAdditionThreeType } from "../value-addition3-types/value-addition-three.entity";
import { Grades } from "../grades/grades.entity";
@Injectable()

export class DeheadingPeelingService{
    constructor(
        @InjectRepository(DeheadingPeelingEntity) private deheadingpeelingRepository: Repository<DeheadingPeelingEntity>,
        private deheadingPeelingAdapter:DeheadingPeelingAdapter ,
      ) { }

        
//     async saveDeheadingPeelingInfo(formData: any): Promise<DeheadingPeelingResponseModel> {
//         // console.log(formData,"oopppppppppoko")
//         const transactionManager = new GenericTransactionManager();
//         try {
//             await transactionManager.startTransaction()
//             const deheadingPeelingRepository = transactionManager.getRepository(DeheadingPeelingEntity);
//             const existingData = await deheadingPeelingRepository.find();
//             // console.log(existingData,"999999999999");
            
          
//             // console.log(deheadingPeelingRepository.save,"91770000000000");
            
//             // const deheadingPeelingLogsRepository = transactionManager.getRepository(DeheadingPeelingLogsEntity);
//             // const deheadingPeelingLogsData = await deheadingPeelingLogsRepository.find();
    
//             // // Update minGrade and maxGrade for DeheadingPeelingLogsEntity
//             // for (const rec of deheadingPeelingLogsData) {
//             //     const gradeParts = rec.grade.split('/');
//             //     const minGrade = parseInt(gradeParts[0]);
//             //     const maxGrade = parseInt(gradeParts[1]);
//             //     rec.minGrade = minGrade;
//             //     rec.maxGrade = maxGrade;
//             //     await deheadingPeelingLogsRepository.save(rec);
//             // }
    
//             for (const rec of existingData){
//                 // console.log(rec,);
//                 const gradeParts =rec.grade.split('/');
//                 const minGrade =parseInt(gradeParts[0]);
//                 const maxGrade=parseInt(gradeParts[1]);
//                 // rec.minGrade=minGrade;
//                 // rec.maxGrade=maxGrade;
//                 const existingData=await transactionManager.getRepository(DeheadingPeelingLogsEntity).findOne({where:{grade:rec.grade}});
//                 if (existingData){
//                     existingData.ratePerKg=rec.ratePerKg;
//                     await transactionManager.getRepository(DeheadingPeelingLogsEntity).save(existingData)
//                 }else{
//                     const newRecord = new DeheadingPeelingLogsEntity();
//                     newRecord.effectiveCreatedAt=rec.createdAt;
//                     newRecord.scopeOfWork=rec.scopeOfWork;
//                     newRecord.grade=rec.grade;
//                     newRecord.effectiveDeheadingPeelingId=rec.deheadingpeelingId;
//                     newRecord.deheadingpeelingId=rec.deheadingpeelingId;
//                     newRecord.minGrade=minGrade;
//                     newRecord.maxGrade=maxGrade;
//                     newRecord.ratePerKg=rec.ratePerKg;

//                     await transactionManager.getRepository(DeheadingPeelingLogsEntity).save(newRecord);
//                 }
//                 const existingPriceListRecord = await deheadingPeelingRepository.findOne({ where: { grade: rec.grade } });

//                 if (existingPriceListRecord) {
//                     // If record exists, update the price
//                     existingPriceListRecord.ratePerKg = rec.ratePerKg;
//                     await deheadingPeelingRepository.save(existingPriceListRecord);
//                 } else {
//                     // If no record exists, create a new one
//                     const newPriceListRecord = new DeheadingPeelingEntity();
//                     newPriceListRecord.grade = rec.grade;
//                     newPriceListRecord.minGrade=minGrade;
//                     newPriceListRecord.maxGrade=maxGrade;
//                     newPriceListRecord.ratePerKg = rec.ratePerKg;
//                     // await deheadingPeelingRepository.save(newPriceListRecord);
//                     console.log(newPriceListRecord,'splittttttttttttt');
                    
//                     await transactionManager.getRepository(DeheadingPeelingEntity).save(newPriceListRecord);


//                 }
            
//             }
         
//             // const count this.rmCountPriceListRepository.
//             const flag = new Set<boolean>()
//             const columnArray = []
//             const updatedArray = formData.map((obj) => {
//                 const updatedObj = {}
//                 for (const key in obj) {
//                     const newKey = key.replace(/\s/g, '').replace(/[\(\)\.]/g, '').replace(/-/g, '');
//                     if (newKey != '') {
//                         columnArray.push(newKey);
//                         updatedObj[newKey] = obj[key];
//                     }
//                 }
//                 return updatedObj;
//             })
//             const difference = columnArray.filter((element) => !DeheadingPeelingColumns.includes(element));
//             // console.log(difference,"difference")
//             if (difference.length > 0) {
//                 await transactionManager.releaseTransaction();
//                 return new DeheadingPeelingResponseModel(false, 1110, "Excel columns doesn't match. Please attach the correct file.");
//             }

//             const convertedData = updatedArray.map((obj) => {
//                 const updatedObj = {};
//                 for (const key in obj) {
//                     const value = obj[key];
//                     if (value === "") {
//                         updatedObj[key] = null;
//                     } else {
//                         updatedObj[key] = value;
//                     }
//                 }
//                 return updatedObj;
//             });
//             const deleteData = await transactionManager.getRepository(DeheadingPeelingEntity).delete({})
//             if (deleteData) {
//                 flag.add(true)
//             } else {
//                 flag.add(false)
//                 return new DeheadingPeelingResponseModel(false, 0, 'Something went wrong in data deletion')
//             }
//             for (const data of convertedData) {
//                 if (data) {
// // console.log(data,"llllllllllll");

//                     const addObj = new DeheadingPeelingEntity()
//                     addObj.scopeOfWork = data.SCOPEOFWORK
//                     addObj.grade = data.GRADE
//                     addObj.ratePerKg = data.RATEPERKG
//                     const addSave = await transactionManager.getRepository(DeheadingPeelingEntity).save(addObj)
//                     if (addSave) {
//                         flag.add(true)
//                     } else {
//                         flag.add(false)
//                         await transactionManager.releaseTransaction();
//                         break;
//                     }
//                 } 
//             }
//             if (!flag.has(false)) {
//                 await transactionManager.completeTransaction();
//                 return new DeheadingPeelingResponseModel(true, 1, 'Data saved successfully');
//             } else {
//                 await transactionManager.releaseTransaction();
//                 return new DeheadingPeelingResponseModel(false, 0, 'Something went wrong');
//             }
//         } catch (err) {
//             await transactionManager.releaseTransaction();
//             return new DeheadingPeelingResponseModel(false, 0, 'Something went wrong');
//         }
//     }

    async getDeheadingPeelingInfo(): Promise<DeheadingPeelingResponseModel> {
        try {
            const info = await this.deheadingpeelingRepository.find()
            let res =[]
            if (info) {
                for(const val of info){
                    const response = new DeheadingPeelingRequest(val.deheadingpeelingId,val.scopeOfWork,val.grade,val.minGrade,val.maxGrade,val.ratePerKg,val.isActive,val.createdUser,val.updatedAt,val.updatedUser,val.versionFlag,val.createdAt,val.foodTypeId,val.valueAdd1,val.valueAdd2,val.basedon,val.valueAdd3,val.isRRP?'true':'false')
                    res.push(response)
                }
                return new DeheadingPeelingResponseModel(true, 1, 'Data retrieved', res)
            } else {
                return new DeheadingPeelingResponseModel(false, 0, 'No data found')
            }
        } catch (err) {
            return new DeheadingPeelingResponseModel(false, 0, 'Something went wrong', err)
        }
    }

    async getDeheadingPeelingtInfoCount(req: any): Promise<DeheadingPeelingResponseModel> {
        try {
            const countWithoutSpaces = req.country.replace(/\s/g, '%'); // Replace spaces with %
            const val = await this.deheadingpeelingRepository.findOne({
                where: {
                    count: Like(`%${countWithoutSpaces}%`) // Search for the modified country string
                }
            });
            if (val) {
                // for(const val of info[0]){
                    const response = new DeheadingPeelingRequest(val.deheadingpeelingId,val.scopeOfWork,val.grade,val.minGrade,val.maxGrade,val.ratePerKg,val.isActive,val.createdUser,val.updatedAt,val.updatedUser,val.versionFlag,val.createdAt,val.foodTypeId,val.valueAdd1,val.valueAdd2,val.basedon,val.valueAdd3,val.isRRP?'true':'false')
                    
                // }
                return new DeheadingPeelingResponseModel(true, 1, 'Data retrieved', [response]);
            } else {
                return new DeheadingPeelingResponseModel(false, 0, 'No data found');
            }
        } catch (err) {
            return new DeheadingPeelingResponseModel(false, 0, 'Something went wrong', err);
        }
    }

    async saveDeheadingPeelingInfoed(formData: any): Promise<DeheadingPeelingResponseModel> {
        // console.log(formData, 'Form Data');
        // console.log(formData.basedon, "Based On");
    
        const transactionManager = new GenericTransactionManager();
        try {
            await transactionManager.startTransaction();
            const flag = new Set<boolean>();
            const columnArray = [];
    
            const updatedArray = formData.data.map((obj) => {
                const updatedObj = {};
                for (const key in obj) {
                    const newKey = key.replace(/\s/g, '').replace(/[\(\)\.]/g, '').replace(/-/g, '');
                    if (newKey != '') {
                        columnArray.push(newKey);
                        updatedObj[newKey] = obj[key];
                    }
                }
                return updatedObj;
            });
            // console.log(columnArray,'ppppppppppfewa');
    
            const difference = columnArray.filter((element) => !DeheadingPeelingColumns.includes(element));
            console.log(difference,'pppppp');
            if (difference.length > 0) {
                await transactionManager.releaseTransaction();
                return new DeheadingPeelingResponseModel(false, 1110, "Excel columns don't match. Please attach the correct file.");
            }
    
            const convertedData = updatedArray.map((obj) => {
                const updatedObj = {};
                for (const key in obj) {
                    const value = obj[key];
                    updatedObj[key] = value === "" ? null : value;
                }
                return updatedObj;
            });
    
            for (const data of convertedData) {
                const valAdd1Data = await transactionManager.getRepository(ValueAdditionOneType).findOne({ where: { name: data.VALUEADDITION1 } });
                const valAdd2Data = await transactionManager.getRepository(ValueAdditionTwoType).findOne({ where: { name: data.VALUEADDITION2 } });
                const valAdd3Data = await transactionManager.getRepository(ValueAdditionThreeType).findOne({ where: { name: data.VALUEADDITION3 } });
                const foodTypeData = await transactionManager.getRepository(FoodType).findOne({ where: { foodType: data.FOODTYPE } });
    
                const isRrp = data.RRPPRICE?.toLowerCase() === 'yes' ? true : false;
                const grade = await transactionManager.getRepository(Grades).findOne({ where: {gradeName : data.GRADE}})
                // console.log(isRrp,'isRrp');
    
                const existingData = await transactionManager.getRepository(DeheadingPeelingEntity).find({
                    where: {
                        grade: data.GRADE,
                        foodTypeId: foodTypeData?.foodTypeId,
                        valueAdd1: valAdd1Data?.valueAdditionOneId,
                        valueAdd2: valAdd2Data?.valueAdditionTwoId,
                        valueAdd3: valAdd3Data?.valueAdditionThreeId,
                        basedon:formData.basedon
                    }
                });
    console.log(grade,'grade');
                if (existingData.length > 0) {
                    const recordWithSameBasedon = existingData.find(record => record.basedon === formData.basedon);
    
                    if (recordWithSameBasedon) {
                        const updateExistedData = await transactionManager.getRepository(DeheadingPeelingEntity).update(
                            { deheadingpeelingId: recordWithSameBasedon.deheadingpeelingId },
                            {
                                ratePerKg: data.RATEPERKG,
                                scopeOfWork: data.SCOPEOFWORK,
                                isRRP: isRrp,
                                updatedUser: recordWithSameBasedon.createdUser
                            }
                        );
    
                        if (!updateExistedData) {
                            flag.add(false);
                            await transactionManager.releaseTransaction();
                            return new DeheadingPeelingResponseModel(false, 0, 'Something went wrong in data updation');
                        } else {
                            flag.add(true);
                            const entityLogObj = new DeheadingPeelingLogsEntity();
                            const gradeParts = recordWithSameBasedon.grade.split('/');
                            const minGrade = grade.gradeMinCount;
                            const maxGrade = grade.gradeMaxCount;
    
                            entityLogObj.grade = recordWithSameBasedon.grade;
                            entityLogObj.minGrade = minGrade;
                            entityLogObj.maxGrade = maxGrade;
                            entityLogObj.ratePerKg = recordWithSameBasedon.ratePerKg;
                            entityLogObj.scopeOfWork = recordWithSameBasedon.scopeOfWork;
                            entityLogObj.deheadingpeelingId = recordWithSameBasedon.deheadingpeelingId;
                            entityLogObj.foodTypeId = recordWithSameBasedon.foodTypeId;
                            entityLogObj.valueAdd1 = recordWithSameBasedon.valueAdd1;
                            entityLogObj.valueAdd2 = recordWithSameBasedon.valueAdd2;
                            entityLogObj.valueAdd3 = recordWithSameBasedon.valueAdd3;
                            entityLogObj.isRRP = isRrp
                            entityLogObj.basedon = formData.basedon;
    
                            const saveLogData = await transactionManager.getRepository(DeheadingPeelingLogsEntity).save(entityLogObj);
                            if (!saveLogData) {
                                flag.add(false);
                                await transactionManager.releaseTransaction();
                                return new DeheadingPeelingResponseModel(false, 0, 'Something went wrong in log creation');
                            }
                        }
                    } else {
                        const entityObj = new DeheadingPeelingEntity();
                        const gradeParts = data?.GRADE?.split('/');
                        const minGrade = grade.gradeMinCount;
                        const maxGrade = grade.gradeMaxCount;
    
                        entityObj.grade = data.GRADE;
                        entityObj.maxGrade = maxGrade;
                        entityObj.minGrade = minGrade;
                        entityObj.ratePerKg = data.RATEPERKG;
                        entityObj.scopeOfWork = data.SCOPEOFWORK;
                        entityObj.foodTypeId = foodTypeData?.foodTypeId;
                        entityObj.valueAdd1 = valAdd1Data?.valueAdditionOneId;
                        entityObj.valueAdd2 = valAdd2Data?.valueAdditionTwoId;
                        entityObj.valueAdd3 = valAdd3Data?.valueAdditionThreeId;
                        entityObj.isRRP = isRrp
                        entityObj.basedon = formData.basedon;
                        entityObj.createdUser = formData.user;
    
                        const saveData = await transactionManager.getRepository(DeheadingPeelingEntity).save(entityObj);
                        if (!saveData) {
                            flag.add(false);
                            await transactionManager.releaseTransaction();
                            return new DeheadingPeelingResponseModel(false, 0, 'Something went wrong in data creation');
                        }
                    }
                } else {
                    const entityObj = new DeheadingPeelingEntity();
                    const gradeParts = data.GRADE.split('/');
                    const minGrade = grade.gradeMinCount;
                    const maxGrade = grade.gradeMaxCount;
                    entityObj.grade = data.GRADE;
                    entityObj.maxGrade = maxGrade;
                    entityObj.minGrade = minGrade;
                    entityObj.ratePerKg = data.RATEPERKG;
                    entityObj.scopeOfWork = data.SCOPEOFWORK;
                    entityObj.foodTypeId = foodTypeData?.foodTypeId;
                    entityObj.valueAdd1 = valAdd1Data?.valueAdditionOneId;
                    entityObj.valueAdd2 = valAdd2Data?.valueAdditionTwoId;
                    entityObj.valueAdd3 = valAdd3Data?.valueAdditionThreeId;
                    entityObj.isRRP = isRrp;
                    entityObj.basedon = formData.basedon;
                    entityObj.createdUser = formData.user;
                    console.log(entityObj,'ooooooooooooo');
                    
                    const saveData = await transactionManager.getRepository(DeheadingPeelingEntity).save(entityObj);
                    if (!saveData) {
                        flag.add(false);
                        await transactionManager.releaseTransaction();
                        return new DeheadingPeelingResponseModel(false, 0, 'Something went wrong in data creation');
                    }
                }
            }
    
            if (!flag.has(false)) {
                await transactionManager.completeTransaction();
                return new DeheadingPeelingResponseModel(true, 1, 'Data Created Successfully');
            } else {
                await transactionManager.releaseTransaction();
                return new DeheadingPeelingResponseModel(false, 0, 'Something went wrong');
            }
    
        } catch (err) {
            console.log(err, 'Error');
            await transactionManager.releaseTransaction();
            return new DeheadingPeelingResponseModel(false, 0, 'Something went wrong');
        }
    }
    

    async getAllPeelingInfo(req: DeheadingFilterReq):Promise<CommonResponse>{
        try{
            const manager = getManager()
            let query = `SELECT dp.scope_of_work AS scopeOfWork,dp.grade,dp.rate_per_kg AS ratePerKg,
            dp.food_type_id AS foodTypeId,ft.food_type AS foodType,dp.based_on as basedOn,dp.is_rrp as isRRP,
            dp.value_add_1 AS valueAdd1Id,vd1t.name AS valueAdd1,
            dp.value_add_2 AS valueAdd2Id,vd2t.name AS valueAdd2,dp.updated_at as date,
            dp.value_add_3 as valueAdd3Id,vd3t.name AS valueAdd3
            FROM `+appSettings.masters_db+`.deheading_peeling_chart dp
            LEFT JOIN `+appSettings.masters_db+`.food_types ft ON ft.food_type_id = dp.food_type_id
            LEFT JOIN `+appSettings.masters_db+`.value_addition_one_types vd1t ON vd1t.value_addition_one_id = dp.value_add_1
            LEFT JOIN `+appSettings.masters_db+`.value_addition_two_types vd2t ON vd2t.value_addition_two_id = dp.value_add_2
            LEFT JOIN `+appSettings.masters_db+`.value_addition_three_types vd3t ON vd3t.value_addition_three_id = dp.value_add_3
            WHERE 1=1`
            if(req.foodTypeId != undefined){
                query=query+' and dp.food_type_id ='+req.foodTypeId+''
            }
            if(req.valueAdd1 != undefined){
                query =query+' and dp.value_add_1='+req.valueAdd1+''
            }
            if(req.valueAdd2 != undefined){
                query=query+' and dp.value_add_2 ="'+req.valueAdd2+'"'
            }
            if(req.basedOn != undefined){
                query += ' and dp.based_on = "'+req.basedOn+'"'
            }
            query = query +` ORDER BY dp.grade`
            const data = await manager.query(query)

            if(data.length > 0){
                return new CommonResponse(true, 1,'Data retrieved successfully',data)
            }else{
                return new CommonResponse(false, 0, 'Data not found',[])
            }
        }catch(err){
            throw(err)
        }
    }

    async getFoodTypes():Promise<CommonResponse>{
        try{
            const manager = getManager()
            let query = `SELECT dp.food_type_id AS foodTypeId,ft.food_type AS foodType
            FROM `+appSettings.masters_db+`.deheading_peeling_chart dp
            LEFT JOIN `+appSettings.masters_db+`.food_types ft ON ft.food_type_id = dp.food_type_id
            WHERE ft.food_type IS NOT NULL
            GROUP BY ft.food_type
            ORDER BY ft.food_type`
            const data = await manager.query(query)
            if(data.length > 0){
                return new CommonResponse(true, 1,'Data retrieved successfully',data)
            }else{
                return new CommonResponse(false, 0, 'Data not found',[])
            }
        }catch(err){
            throw(err)
        }
    }

    async getValueAdd1():Promise<CommonResponse>{
        try{
            const manager = getManager()
            let query = `SELECT dp.value_add_1 AS valueAdd1Id,vd1t.name AS valueAdd1
            FROM `+appSettings.masters_db+`.deheading_peeling_chart dp
            LEFT JOIN `+appSettings.masters_db+`.value_addition_one_types vd1t ON vd1t.value_addition_one_id = dp.value_add_1
            WHERE vd1t.name IS NOT NULL
            GROUP BY vd1t.name
            ORDER BY vd1t.name`
            const data = await manager.query(query)
            if(data.length > 0){
                return new CommonResponse(true, 1,'Data retrieved successfully',data)
            }else{
                return new CommonResponse(false, 0, 'Data not found',[])
            }
        }catch(err){
            throw(err)
        }
    }

    async getValueAdd2():Promise<CommonResponse>{
        try{
            const manager = getManager()
            let query = `SELECT dp.value_add_2 AS valueAdd2Id,vd2t.name AS valueAdd2
            FROM `+appSettings.masters_db+`.deheading_peeling_chart dp
            LEFT JOIN `+appSettings.masters_db+`.value_addition_two_types vd2t ON vd2t.value_addition_two_id = dp.value_add_2
            WHERE vd2t.name IS NOT NULL
            GROUP BY vd2t.name
            ORDER BY vd2t.name`
            const data = await manager.query(query)
            if(data.length > 0){
                return new CommonResponse(true, 1,'Data retrieved successfully',data)
            }else{
                return new CommonResponse(false, 0, 'Data not found',[])
            }
        }catch(err){
            throw(err)
        }
    }

    
  async getScopeOfWorkDropdown():Promise<CommonResponse>{
    const manager = getManager()
    try{
      const getScopeOfWorkQry = `SELECT DISTINCT(scope_of_work) AS scopeOfWork FROM ${appSettings.masters_db} .deheading_peeling_chart`
      const scopeOfWorkInfo = await manager.query(getScopeOfWorkQry)

      if(scopeOfWorkInfo.length > 0){
        return new CommonResponse(true,1,'Data retrieved sucessfully',scopeOfWorkInfo)
      }else{
        return new CommonResponse(false,0,'No data found')
      }
    }catch(err){
      throw err
    }
  }

  async getPellingRateAgainstScopeAndGrade(req:ScopeGradeReq):Promise<CommonResponse>{
    const manager = getManager()
    try{
        if (String(req.grade).includes('-')) {
        req.grade = Number(String(req.grade).split('-')[0]);
      }
        let qry = `SELECT deheading_peeling_chart_id,rate_per_kg AS rate FROM ${appSettings.masters_db} .deheading_peeling_chart WHERE scope_of_work = '${req.scope}' AND based_on = '${req.priceBasedOn}' AND ${req.grade} >= min_grade AND ${req.grade} <= max_grade`
        // if(req.operation == OperationTypeEnum.PACKING){
        //     const grade = String(req.grade).replace("-", "/");
        //     qry += ` AND grade = '${grade}'`
        // }else{
        //     qry += ` AND ${req.grade} >= min_grade AND ${req.grade} <= max_grade `
        // }
        if(req.isRRP != undefined){
            qry += ` AND is_rrp = ${req.isRRP}`
        }
        const info = await manager.query(qry)
        if(info.length >0){
            return new CommonResponse(true,1,'Data retrieved',info)
        }else{
            return new CommonResponse(false,0,'No data found')
        }

    }catch(err){
        throw err
    }
  }

}